import { MissionData } from '../blocks/mission'
import template from './templates/RJS09.rbxl'
import thumbnail1 from './thumbnails/RJS09/CheckPoint1.png'
import thumbnail2 from './thumbnails/RJS09/CheckPoint2.png'
import thumbnail3 from './thumbnails/RJS09/SpawnLocation.png'
import thumbnail4 from './thumbnails/RJS09/Block.png'
const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}, {}],
  objects: [
    {
      name: '①チェックポイント1',
      thumbnail: thumbnail1,
      sound: true,
    },
    {
      name: '②チェックポイント2',
      thumbnail: thumbnail2,
    },
    {
      name: '③スタートちてん',
      thumbnail: thumbnail3,
    },
    {
      name: '④ブロック',
      thumbnail: thumbnail4,
    },
  ],
}

export default mission
